import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const PlatformWrap = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 61px;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  @media (min-width: 769px) {
    margin-top: 230px;
  }
`;

export const Title = styled.h1`
  font-size: 36px;
  color: ${colors.GREY_DARK};
  font-family: ${fonts.abhayaBold};
  line-height: 42px;
  max-width: 340px;
  width: 100%;
  text-align: center;
  margin-bottom: 27px;
  @media (min-width: 769px) {
    line-height: 57px;
    max-width: 506px;
    font-size: 48px;
  }
`;
export const SubTitle = styled.span`
  margin: 0;
  color: ${(props) => (props.color === "red" ? colors.RED : colors.GREY_DARK)};
`;
export const GreenTitle = styled.span`
  color: ${colors.RED};
`;

export const Text = styled.p`
  color: ${colors.GREY_SEMIDARK};
  font-family: ${fonts.latoRegular};
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  width: 800px;
  text-align: center;
  margin-top: -18px;
  @media (max-width: 768px) {
    font-size: 16px;
    width: 330px;
  }
`;

export const Slider = styled.div`
  width: 100%;
  height: 182px;
  background-image: url("/images/platform.png");
  margin-top: 41px;
  @media (max-width: 768px) {
    margin-top: 44px;
    background-position: center 0;
    background-size: cover;
  }
  @media (min-width: 769px) {
    background-repeat-x: repeat;
    background-repeat-y: no-repeat;
    background-size: contain;
  }
`;
